import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, Partners, FAQs, NewsletterSection, Mission } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Counter />
        <Services />
        <Mission />
        <Team />
        <Testimonials />
        <FAQs />
        <NewsletterSection />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;